// this one was working

// import React, { useState, Fragment, useEffect, useRef } from "react";

// import "./style.css";
// import data from "./mock-data.json";
// import ReadOnlyRow from "./ReadOnlyRow";
// import EditableRow from "./EditableRow";

// import Cookies from "js-cookie";

// import { Circles } from "react-loader-spinner";

// import { confirmAlert } from "react-confirm-alert";
// import "react-confirm-alert/src/react-confirm-alert.css";

// import RecordsDashboardClerk from "./RecordsDashboardClerk";

// //receipt component
// import Receipt from "../../twAdmin/twRecords/receipts/Receipt";

// import ClassPrinter from "../../twAdmin/twRecords/receipts/ClassPrinter";

// //pdf creator
// import jsPDF from "jspdf";
// // import "jspdf-autotable";

// // import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';

// import { useSelector } from "react-redux";
// import { fetchCompanies } from "../../../redux/companySlice";
// import { useDispatch } from "react-redux";



// const Records = () => {
//   const options = [
//     { value: "", text: "-- choose product type --" },
//     { value: "coffee", text: "coffee" },
//     { value: "tea leaves", text: "tea leaves" },
//     { value: "milk", text: "milk" },
//   ];

//   //store select company values in an array
//   const companies = [
//     { value: "", text: "-- select company--" },
//     { value: "Terraweb", text: "Terraweb" },
//     { value: "Gatamura Dairy", text: "Gatamura Dairy" },
//     { value: "Mbuuni Coffee", text: "Mbuuni Coffee" },
//     { value: "Kanyua Tea", text: "Kanyua Tea" },
//   ];

//   const [names, setNames] = useState({
//     producttype: options[0].value,
//     company: companies[0].value,
//   });

//   const [foundUsers, setFoundUsers] = useState();

//   const [contacts, setContacts] = useState(data);
//   const [addFormData, setAddFormData] = useState({
//     id: "",
//     fullname: "",
//     farmerid: "",
//     firstName: "",
//     lastName: "",
//     producttype: "",
//     daterecorded: "",
//     company: "",
//     weight: "",
//   });

//   const [editFormData, setEditFormData] = useState({
//     id: "",
//     fullname: "",
//     producttype: "",
//     daterecorded: "",
//     companyname: "",
//     weight: "",
//   });


//   //dispatch companies from the redux store
//   const dispatch = useDispatch();
//   //fetch companies using get

//   const companiesList = useSelector((state) => state.companies?.list || []);

//   useEffect(() => {
//     dispatch(fetchCompanies());
//   }, [dispatch]);


//   const [editContactId, setEditContactId] = useState(null);

//   //lookup farmer id and set state to show labe if found
//   const [foundFarmer, setFoundFarmer] = useState(null);

//   //display success info after successful registration
//   const [success, setSuccess] = useState("");

//   const [foundErr, setFoundErr] = useState(null);
//   const [foundErrAdd, setFoundErrAdd] = useState(null);
//   const [isLoading, setIsLoading] = useState(null);
//   const [isLoadingAdd, setIsLoadingAdd] = useState(false);
//   const [isLoadingSave, setIsLoadingSave] = useState(null);

//   //when record is successfully added
//   const [successAdd, setSuccessAdd] = useState(null);

//   //analysis Constants
//   const [totalRecords, settotalRecords] = useState(null);

//   //search users in your company
//   const [searchRecord, setSearchRecord] = useState("");

//   const [deleteState, setDeleteState] = useState("");

//   //clear inputs
//   const usernameRef = useRef();
//   const emailRef = useRef();
//   const passwordRef = useRef();

//   //use ref to fill inputs or clear them
//   const firtNameRef = useRef();
//   const lastNameRef = useRef();
//   const companyRef=useRef();

//   //creating a fullname formatter here so that fullname data goes into the dataabase in the
//   //form of firstname Lastname
//   // Function to format the full name
//   const formatFullName = (firstName, lastName) => {
//     // Ensure the first letter of each name is capitalized
//     const formattedFirstName =
//       firstName.charAt(0).toUpperCase() + firstName.slice(1);
//     const formattedLastName =
//       lastName.charAt(0).toUpperCase() + lastName.slice(1);

//     // Combine the formatted names into the full name
//     const fullName = `${formattedFirstName} ${formattedLastName}`;

//     return fullName;
//   };

//   //format the company to start with capital letter and remove white spaces
//   // Function to format the company name
//   const formatCompanyName = (input) => {
//     // Remove leading and trailing white spaces
//     const trimmedInput = input.trim();

//     // Ensure the first letter is capitalized
//     const formattedCompanyName =
//       trimmedInput.charAt(0).toUpperCase() + trimmedInput.slice(1);

//     return formattedCompanyName;
//   };

//   //handle product type input
//   const onProducttypeChange = (event) => {
//     // if (names.gender.length >= 1) {
//     //   setFlag(1);
//     // } else {
//     //   setFlag(2);
//     // }
//     // Spreading "...state" ensures we don't "lose" fname,lname,email... etc
//     setNames((names) => ({
//       ...names,
//       producttype: event.target.value,
//     }));

//     //update the form fields before updating
//     event.preventDefault();

//     const fieldName = event.target.getAttribute("name");
//     const fieldValue = event.target.value;

//     const newFormData = { ...addFormData };
//     newFormData[fieldName] = fieldValue;

//     setAddFormData(newFormData);
//   };

//   useEffect(() => {
//     //fetch records
//     const fetchAll = () => {
//       try {
//         let adminCookie = Cookies.get("sessionidadmin");
//         let userCookie = Cookies.get("sessioniduser");
//         if (adminCookie.length >= 8 || userCookie.length >= 8) {
//           setIsLoading(true);

//           setTimeout(() => {
//                       fetch("https://api.terraweb.africa/getDailyRecords", {

//               method: "post",
//               headers: { "Content-Type": "application/JSON" },
//               body: JSON.stringify({
//                 adminid: adminCookie,
//                 userid: userCookie,
//               }),
//             })
//               .then(function (response) {
//                 if (response.status === 400) {
//                   throw Error("Wrong credentials");
//                 }
//                 if (response === 500) {
//                   throw Error("Could not complete request because of an error");
//                 }

//                 return response.json();
//               })
//               .then((user) => {
//                 if (user[0].id >= 1) {
//                   setFoundErr(null);

//                   setIsLoading(null);
//                   setContacts(user);
//                   // loadAnalysis(user);

//                   //load data
//                 } else {
//                   //dont load

//                   setFoundErr(null);
//                   setIsLoading(null);
//                 }
//               })
//               .catch((err) => {
//                 // setFoundErr(err.message);
//                 setIsLoading(null);
//                 // setFlag(1);
//               });
//           }, 2000);
//         } else {
//           setIsLoading(null);
//         }
//       } catch (error) { }
//     };

//     //load profile
//     const fetchProfile = () => {
//       let adminCookie = "";
//       adminCookie = Cookies.get("sessionidadmin");
//       let userid = "";
//       userid = Cookies.get("sessioniduser");
//       if (adminCookie.length >= 1 || userid.length >= 1) {
//         setIsLoading(true);
//         setTimeout(() => {
//           fetch("https://api.terraweb.africa/loadProfile", {
//             method: "post",
//             headers: { "Content-Type": "application/JSON" },
//             body: JSON.stringify({
//               adminid: adminCookie,
//               userid: userid,
//             }),
//           })
//             .then(function (response) {
//               if (response.status === 400) {
//                 throw Error("Wrong credentials");
//               }
//               if (response === 500) {
//                 throw Error("Could not complete request because of an error");
//               }

//               return response.json();
//             })
//             .then((user) => {
//               if (user[0].username.length >= 1) {
//                 //load data

//                 setFoundErrAdd(null);

//                 setIsLoading(null);
//                 setContacts(user);

//                 setSuccess(null);
//                 setDeleteState(null);

//                 //store a name after load to display in the title of the users table
//                 setNames((names) => ({
//                   ...names,
//                   company: user[0].company,
//                 }));

//                 setAddFormData((prevState) => ({
//                   ...prevState,
//                   company: user[0].company,
//                 }));
//               } else {
//                 //dont load

//                 setFoundErrAdd(null);
//                 setFoundErr(null);
//                 setIsLoading(null);
//                 setDeleteState(null);
//               }
//             })
//             .catch((err) => {
//               // setFoundErr(err.message);
//               setIsLoading(null);
//               // setFlag(1);
//             });
//         }, 150);
//       } else {
//         setIsLoading(null);
//       }
//     };

//     fetchAll();
//     fetchProfile();
//   }, []);

//   // timer for success and error message
//   // Success/Error auto-hide after 8 seconds
//   useEffect(() => {
//     if (successAdd || foundErrAdd) {
//       const timer = setTimeout(() => {
//         setSuccessAdd("");
//         setFoundErrAdd("");
//       }, 8000);

//       return () => clearTimeout(timer); // cleanup
//     }
//   }, [successAdd, foundErrAdd]);

//   //load analysis
//   const loadAnalysis = (datamap) => { };

//   //search records
//   const searchRecords = () => {
//     // setContacts(null);
//     //fetch cookie
//     let adminCookie = Cookies.get("sessionidadmin");
//     if (adminCookie.length >= 1) {
//       setIsLoading(true);

//       setTimeout(() => {
//         fetch("https://api.terraweb.africa/searchRecords", {
//           method: "post",
//           headers: { "Content-Type": "application/JSON" },
//           body: JSON.stringify({
//             adminid: adminCookie,

//             fullname: searchRecord,

//             userid: searchRecord,
//           }),
//         })
//           .then(function (response) {
//             if (response.status === 400) {
//               throw Error("Wrong credentials");
//             }
//             if (response === 500) {
//               throw Error("Could not complete request because of an error");
//             }

//             return response.json();
//           })
//           .then((user) => {
//             if (user[0].id >= 1) {
//               setFoundErr(null);
//               setFoundErrAdd(null);
//               setDeleteState(null);

//               setIsLoading(null);
//               setContacts(user);
//               loadAnalysis(user);

//               //load data
//             } else {
//               //dont load

//               setFoundErr(null);
//               setFoundErrAdd(null);
//               setIsLoading(null);
//               setDeleteState(null);
//             }
//           })
//           .catch((err) => {
//             // setFoundErr(err.message);
//             setIsLoading(null);
//             // setFlag(1);
//           });
//       }, 1500);
//     } else {
//       setIsLoading(null);
//     }
//   };

//   //handle search user
//   const onSearchChange = (event) => {
//     event.preventDefault();
//     setSearchRecord(event.target.value);
//   };

//   //fetch users
//   const fetchRecords = () => {
//     try {
//       let adminCookie = Cookies.get("sessionidadmin");
//       let userCookie = Cookies.get("sessioniduser");
//       if (adminCookie.length >= 8 || userCookie.length >= 8) {
//         setIsLoading(true);

//         setTimeout(() => {
//                 fetch("https://api.terraweb.africa/getDailyRecords", {

//             method: "post",
//             headers: { "Content-Type": "application/JSON" },
//             body: JSON.stringify({
//               adminid: adminCookie,
//               userid: userCookie,
//             }),
//           })
//             .then(function (response) {
//               if (response.status === 400) {
//                 throw Error("Wrong credentials");
//               }
//               if (response === 500) {
//                 throw Error("Could not complete request because of an error");
//               }

//               return response.json();
//             })
//             .then((user) => {
//               if (user[0].id >= 1) {
//                 setFoundErr(null);

//                 setIsLoading(null);
//                 setContacts(user);
//                 // loadAnalysis(user);

//                 //load data
//               } else {
//                 //dont load

//                 setFoundErr(null);
//                 setIsLoading(null);
//               }
//             })
//             .catch((err) => {
//               // setFoundErr(err.message);
//               setIsLoading(null);
//               // setFlag(1);
//             });
//         }, 2000);
//       } else {
//         setIsLoading(null);
//       }
//     } catch (error) { }
//   };

//   //load profile
//   const fetchProfile = () => {
//     let adminCookie = "";
//     adminCookie = Cookies.get("sessionidadmin");
//     let userid = "";
//     userid = Cookies.get("sessioniduser");
//     if (adminCookie.length >= 1 || userid.length >= 1) {
//       setIsLoading(true);
//       setTimeout(() => {
//         fetch("https://api.terraweb.africa/loadProfile", {
//           method: "post",
//           headers: { "Content-Type": "application/JSON" },
//           body: JSON.stringify({
//             adminid: adminCookie,
//             userid: userid,
//           }),
//         })
//           .then(function (response) {
//             if (response.status === 400) {
//               throw Error("Wrong credentials");
//             }
//             if (response === 500) {
//               throw Error("Could not complete request because of an error");
//             }

//             return response.json();
//           })
//           .then((user) => {
//             if (user[0].username.length >= 1) {
//               //load data

//               setFoundErrAdd(null);

//               setIsLoading(null);
//               setContacts(user);

//               setSuccess(null);
//               setDeleteState(null);

//               //store a name after load to display in the title of the users table
//               setNames((names) => ({
//                 ...names,
//                 company: user[0].company,
//               }));
//             } else {
//               //dont load

//               setFoundErrAdd(null);
//               setFoundErr(null);
//               setIsLoading(null);
//               setDeleteState(null);
//             }
//           })
//           .catch((err) => {
//             // setFoundErr(err.message);
//             setIsLoading(null);
//             // setFlag(1);
//           });
//       }, 150);
//     } else {
//       setIsLoading(null);
//     }
//   };

//   //check if user exists when full name is typed out
//   const fetchUsers = () => { };



//   //temp handle add form change
//   const handleAddFormChange = (event) => {
//     event.preventDefault();

//     setSuccess(null);
//     setFoundErrAdd(null);

//     const fieldName = event.target.getAttribute("name");
//     let fieldValue = event.target.value;

//     // Check if the field name is "company" and apply formatting if needed
//     if (fieldName === "company") {
//       // Ensure the first letter is capitalized
//       fieldValue = fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1);

//       // Remove trailing white spaces
//       fieldValue = fieldValue.trim();
//       setAddFormData((prevState) => ({
//         ...prevState,
//         company: fieldValue,
//       }));
//     } else if (fieldName === "firstName") {
//       // Handle input changes for first name
//       if (/^[A-Za-z]+$/.test(fieldValue) || fieldValue === "") {
//         const fullName = formatFullName(fieldValue, addFormData.firstName);

//         setAddFormData((prevState) => ({
//           ...prevState,
//           firstName: fieldValue,
//           fullname: fullName,
//         }));
//       }
//     } else if (fieldName === "lastName") {
//       // Handle input changes for last name
//       if (/^[A-Za-z]+$/.test(fieldValue) || fieldValue === "") {
//         const fullName = formatFullName(addFormData.firstName, fieldValue);
//         setAddFormData((prevState) => ({
//           ...prevState,
//           lastName: fieldValue,
//           fullname: fullName,
//         }));
//       }
//     } else {
//       const newFormData = { ...addFormData };
//       newFormData[fieldName] = fieldValue;

//       setAddFormData(newFormData);
//     }
//   };

//   //handle company input
//   const onCompanyChange = (event) => {
//     if (names.company.length >= 3) {
//       //   setFlag(1);
//     } else {
//       //   setFlag(2);
//     }
//     // Spreading "...state" ensures we don't "lose" fname,lname,email... etc
//     setNames((names) => ({
//       ...names,
//       company: event.target.value,
//     }));
//         setAddFormData((prev) => ({
//       ...prev,
//           company: event.target.value,

//     }));
//   };

//   const handleEditFormChange = (event) => {
//     event.preventDefault();

//     const fieldName = event.target.getAttribute("name");

//     const fieldValue = event.target.value;

//     const newFormData = { ...editFormData };
//     newFormData[fieldName] = fieldValue;

//     setEditFormData(newFormData);
//   };

//   //refresh after add records
//   const refreshRecords = () => {
//     fetchRecords();
//   };


//   const handleAddFormSubmit = (event) => {
//     event.preventDefault();

//     setFoundErrAdd("");
//     setSuccessAdd("");

//     const newContact = {
//       farmerid: addFormData.farmerid,
//       companyname: addFormData.company,
//       producttype: addFormData.producttype,
//       weight: addFormData.weight,
//       fullname: addFormData.fullname,
//     };

//     if (
//       newContact.companyname.length >= 3 &&
//       newContact.producttype.length >= 3 &&
//       newContact.fullname.length >= 3 &&
//       String(newContact.weight).length >= 1
//     ) {
//       //send add record request
//       let adminCookie = Cookies.get("sessionidadmin");

//       if (adminCookie && adminCookie.length >= 4) {
//         setIsLoadingAdd(true);

//         setTimeout(() => {
//           fetch("https://api.terraweb.africa/addnewrecord", {
//             method: "post",
//             headers: { "Content-Type": "application/JSON" },
//             body: JSON.stringify({
//               adminid: adminCookie,
//               farmerid: newContact.farmerid,
//               producttype: newContact.producttype,
//               weight: newContact.weight,
//               fullname: newContact.fullname,
//               companyname: newContact.companyname,
//             }),
//           })
//             .then(async function (response) {
//               const data = await response.json();

//               // handle backend errors properly
//               if (!response.ok) {
//                 throw data;
//               }

//               return data;
//             })
//             .then((data) => {
//               setFoundErrAdd(null);
//               setIsLoadingAdd(null);

//               // success message from backend
//               setSuccessAdd(
//                 data.message || "Record added successfully"
//               );

//               // refresh records
//               refreshRecords();

//               // optional clear form
//               setAddFormData({
//                 id: "",
//                 fullname: "",
//                 farmerid: "",
//                 firstName: "",
//                 lastName: "",
//                 producttype: "",
//                 daterecorded: "",
//                 company: "",
//                 weight: "",
//               });
//             })
//             .catch((err) => {
//               console.log("BACKEND ERROR:", err);

//               if (err.missingFields) {
//                 setFoundErrAdd(
//                   `Missing fields: ${err.missingFields.join(
//                     ", "
//                   )}`
//                 );
//               } else if (err.message) {
//                 setFoundErrAdd(err.message);
//               } else {
//                 setFoundErrAdd(
//                   "An unexpected error occurred"
//                 );
//               }

//               setIsLoadingAdd(null);
//             });
//         }, 1000);
//       } else {
//         setFoundErrAdd(
//           "Session expired. Please login again."
//         );
//         setIsLoadingAdd(null);
//       }
//     } else {
//       setFoundErrAdd(
//         "Please fill all required fields correctly."
//       );
//     }
//   };

//    const handleEditFormSubmit = (event) => {
//     event.preventDefault();

//     const editedContact = {
//       id: editFormData.id,
//       companyname: editFormData.companyname,
//       producttype: editFormData.producttype,
//       weight: editFormData.weight,
//       fullname: editFormData.fullname,
//       daterecorded: editFormData.daterecorded,

//     };

//     const newContacts = [...contacts];
//     const index = contacts.findIndex((contact) => contact.id === editContactId);
//     newContacts[index] = editedContact;

//     const adminCookie = Cookies.get("sessionidadmin");

//     if (adminCookie && adminCookie.length >= 1) {
//       setIsLoadingSave(true);

//       fetch("https://api.terraweb.africa/updateRecord", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           id: newContacts[index].id,
//           adminid: adminCookie,
//           fullname: newContacts[index].fullname,
//           companyname: newContacts[index].companyname,
//           producttype: newContacts[index].producttype,
//           weight: newContacts[index].weight,
//           farmerid: contacts[index].farmerid
//         }),
//       })

//         .then((response) => response.json())
//         .then((resData) => {
//           if (resData.success) {
//             setFoundErrAdd(null);
//             setSuccess(resData.message || "Record updated successfully");
//             setIsLoadingSave(false);

//             refreshRecords();
//             setEditContactId(null);
//           } else {
//             setSuccess(null);
//             setFoundErrAdd(resData.error || "Update failed");
//             setIsLoadingSave(false);
//           }
//         })
//         .catch((err) => {
//           setSuccess(null);
//           setFoundErrAdd(err.message || "Unexpected error occurred");
//           setIsLoadingSave(false);
//         });
//     } else {
//       setIsLoadingSave(false);
//       setFoundErrAdd("Session expired or invalid admin ID.");
//     }
//   };


//   const handleEditClick = (event, contact) => {
//     event.preventDefault();
//     setEditContactId(contact.id);

//     const formValues = {
//       id: contact.id,
//       companyname: contact.companyname,
//       producttype: contact.producttype,
//       weight: contact.weight,
//       fullname: contact.fullname,
//       daterecorded: contact.daterecorded,
//     };

//     setEditFormData(formValues);
//   };

//   const handleCancelClick = () => {
//     setEditContactId(null);
//   };

//   //confirm delete record
//   const onDeleteYes = (id) => {
//     let adminCookie = Cookies.get("sessionidadmin");
//     if (adminCookie.length >= 1) {
//       fetch("https://api.terraweb.africa/deleterecord", {
//         method: "post",
//         headers: { "Content-Type": "application/JSON" },
//         body: JSON.stringify({
//           adminid: adminCookie,

//           id: id,
//         }),
//       })
//         .then(function (response) {
//           if (response.status === 400) {
//             throw Error("An error occurred, during delete.");
//           }
//           if (response === 500) {
//             throw Error("Could not complete request because of an error");
//           }

//           return response.json();
//         })
//         .then((user) => {
//           if (user) {
//             refreshRecords();
//           } else {
//             //dont load
//           }
//         })
//         .catch((err) => {
//           // setFlag(1);
//         });
//     } else {
//     }
//   };

//   const handleDeleteClick = (contactemail) => {
//     //delete alert
//     confirmAlert({
//       customUI: ({ onClose }) => {
//         return (
//           <div className="deletediv bg-white br3 bb b--black-10  gold pa2 w-100 shadow-5 center ">
//             <h1>Confirm Delete Record</h1>
//             <p className="f3 black">Sure you want to delete this user record with ID: {contactemail}?</p>
//             <p className="b red f4">
//               Note that this cannot be <b className="red f3">UNDONE</b>
//             </p>
//             <label
//               className="dib w3 tc pa2 f3 ma2 white br-pill bg-red hover-bg-white hover-black "
//               onClick={onClose}
//             >
//               No
//             </label>
//             <label
//               className="dib w6 f5 fr tc pa3 white br-pill bg-blue hover-bg-red hover-white"
//               onClick={() => {
//                 onDeleteYes(contactemail);
//                 onClose();
//               }}
//             >
//               Yes, Delete it!
//             </label>
//           </div>
//         );
//       },
//     });
//   };



//   const handleAutofillNames = () => {
//     if (!foundFarmer?.success) return;

//     const fullname = foundFarmer.data.fullname || "";

//     const names = fullname.split(" ");

//     const firstName = names[0] || "";
//     const lastName = names.slice(1).join(" ") || "";
//     const company = foundFarmer.data.company

//     setAddFormData((prev) => ({
//       ...prev,
//       firstName,
//       lastName,
//       fullname, company
//     }));

//     clearFoundFarmer();
//   };


//   // Function to clear the foundFarmer state
//   const clearFoundFarmer = () => {
//     setFoundFarmer(null); // You can set it to null or an empty object, depending on your use case
//   };


//   const handleLookupFarmerID = async (event) => {
//     event.preventDefault();

//     setFoundErrAdd("");
//     setFoundFarmer(null);

//     try {
//       const farmerid = addFormData.farmerid?.trim();

//       if (!farmerid) {
//         setFoundErrAdd("Enter farmer ID");
//         return;
//       }

//       setIsLoadingAdd(true);

//       const adminCookie = Cookies.get("sessionidadmin");

//       const response = await fetch(
//         "https://api.terraweb.africa/lookupFarmerProfile",
//         {
//           method: "post",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             adminid: adminCookie,
//             farmerid,
//           }),
//         }
//       );

//       const data = await response.json();

//       setIsLoadingAdd(false);

//       setFoundFarmer(data);

//     } catch (err) {
//       setIsLoadingAdd(false);

//       setFoundFarmer({
//         success: false,
//         error: "Could not lookup farmer.",
//       });
//     }
//   };

//   //handle download per row receipt
//   const handleDownloadRow = (contact) => {
//     handlePrint(contact)

//   }
//   const getReceiptText = (data) => {
//     // let adminCookie = Cookies.get("sessionidadmin");

//     const now = new Date();
//     const formattedDate = now.toLocaleDateString("en-KE", {
//       weekday: "long",
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//     });
//     const formattedTime = now.toLocaleTimeString("en-KE");
//     const user = "TWAdmin"

//     const printedBy = user?.name || "Admin";

//     return `
//     Terraweb.africa                 
//     --------------------------------------------------------------------
//     Printed On: ${formattedDate} at ${formattedTime}
//     Printed By: ${printedBy}
//     --------------------------------------------------------------------
//     Company: ${data.companyname}
//     --------------------------------------------------------------------
//     Receipt ID: ${data.id}
//     Username: ${data.fullname}
//     Farmer ID: ${data.farmerid}
//     Weight: ${data.weight}
//     ---------------------------------------------------------------------
//     Total: ${data.weight}
//     ---------------------------------------------------------------------
//     Thank you for choosing Our Company.
//     We Value You.
//     `;
//   };

//   const handlePrint = (contact) => {
//     const receiptText = getReceiptText(contact);
//     const printer = new ClassPrinter();
//     printer.print(receiptText);
//   };

//   //handle download table

//   const handleDownloadTable = () => {
//     const doc = new jsPDF();

//     const currentDate = new Date().toLocaleString();

//     // Header
//     doc.setFontSize(16);
//     doc.text('Terraweb.africa', 14, 15);
//     doc.setFontSize(11);
//     doc.text('Empowering farmers through technology', 14, 22);
//     doc.setFontSize(10);
//     doc.text(`Generated on: ${currentDate}`, 14, 28);

//     // Table data
//     const tableColumn = [
//       'ID',
//       'Farmer ID',
//       'Product Type',
//       'Weight',
//       'Company',
//       'Full Name',
//       'Recorded',
//     ];

//     const tableRows = contacts?.map((contact) => [
//       contact.id,
//       contact.farmerid,
//       contact.producttype,
//       contact.weight,
//       contact.companyname,
//       contact.fullname,
//       contact.daterecorded,
//     ]) || [];

//     autoTable(doc, {
//       head: [tableColumn],
//       body: tableRows,
//       startY: 35,
//       styles: { fontSize: 9, color: "black" },
//       headStyles: { fillColor: [252, 156, 28] },
//       margin: { top: 35, bottom: 20 },
//       didDrawPage: function (data) {
//         // Footer
//         const pageCount = doc.internal.getNumberOfPages();
//         doc.setFontSize(9);
//         doc.text(
//           `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
//           data.settings.margin.left,
//           doc.internal.pageSize.height - 10
//         );

//         // Footer text
//         doc.text(
//           '© Terraweb.africa — All rights reserved.',
//           data.settings.margin.left + 70,
//           doc.internal.pageSize.height - 10
//         );
//       },
//     });

//     // Save PDF
//     doc.save('farmer_records.pdf');
//   };



//   //pagination next
//   const handlePageNext = () => {

//   }

//   const handlePagePrevious = () => {

//   }

// const scrollToFirstName =()=>{
// firtNameRef.current?.scrollIntoView({behavior:"smooth",block:"center"})
// firtNameRef.current?.focus();
// }

//   return (
//     // <div className="app-container center mt6  ">
//     //   {isLoading ? (
//     //     <div className="db mb2">
//     //       <Circles type="Oval" color="#000080" height={40} width={80} />
//     //     </div>
//     //   ) : null}

//     //   <div className="dib-l">
//     //     <div className="controlContainer d-grid bg-white  br4 shadow-3 ">
//     //       <label className="ma2 black pt3 f3 b">
//     //         Total Weight
//     //         <label className="strong red ml2 mr2">{totalRecords}</label>
//     //       </label>

//     //       <label
//     //         className="ma2 black pt3
//     //        f3 b"
//     //       >
//     //         Last Recorded
//     //         <label className="strong red ml2 mr2"></label>
//     //       </label>
//     //       <label className="ma2 pt3 black f3 b">
//     //         View personal records
//     //         <label className="strong red ml2 mr2"></label>
//     //       </label>
//     //       <div className="grid-item pa2 dib ">
//     //         <input
//     //           type="text"
//     //           className="searchInput "
//     //           placeholder="Search Users"
//     //           onChange={onSearchChange}
//     //         />

//     //         <button
//     //           className="  br-pill bw0 bg-orange white hover-bg-yellow tc pa3 "
//     //           type="button"
//     //           onClick={searchRecords}
//     //         >
//     //           <label className="center f4">Search</label>
//     //         </button>
//     //       </div>
//     //       <div className="grid-item flex-ns pa3 mt2 ">
//     //         <label className="f3  mt2">
//     //           Showing <b>1-50</b> of {contacts.length} Entries
//     //         </label>
//     //         <button
//     //           className=" br-pill bw0 ml2 bg-white orange f4  b pa2 hover-bg-orange hover-white"
//     //           type="submit"
//     //           onClick={handleAddFormSubmit}
//     //         >
//     //           back
//     //         </button>
//     //         <button
//     //           className=" br-pill bw0 ml2 bg-white orange f4  b pa2 hover-bg-orange hover-white"
//     //           type="submit"
//     //           onClick={handleAddFormSubmit}
//     //         >
//     //           next
//     //         </button>
//     //       </div>
//     //     </div>
//     //   </div>
//     //   <form onSubmit={handleEditFormSubmit}>
//     //     <table>
//     //       <thead className="">
//     //         <tr>
//     //           <th>ID</th>
//     //           <th>Farmer ID</th>
//     //           <th>Product Type</th>
//     //           <th>Weight</th>
//     //           <th>Company</th>
//     //           <th>Full Name</th>

//     //           <th>Recorded</th>
//     //           <th>Edit records</th>
//     //         </tr>
//     //       </thead>
//     //       <tbody>
//     //         {contacts.map((contact) => (
//     //           <Fragment key={contact.id}>
//     //             {editContactId === contact.id ? (
//     //               <EditableRow
//     //                 handleEditFormSubmit={handleEditFormSubmit}
//     //                 isLoadingSave={isLoadingSave}
//     //                 editFormData={editFormData}
//     //                 handleEditFormChange={handleEditFormChange}
//     //                 handleCancelClick={handleCancelClick}
//     //               />
//     //             ) : (
//     //               <ReadOnlyRow
//     //                 contact={contact}
//     //                 handleEditClick={handleEditClick}
//     //                 handleDeleteClick={handleDeleteClick}
//     //               />
//     //             )}
//     //           </Fragment>
//     //         ))}
//     //       </tbody>
//     //     </table>
//     //   </form>
//     //   <div>
//     //     {foundErr ? <label className="dt red  pb2">{foundErr}</label> : null}

//     //     <button
//     //       className="ml2 br-pill bg-white orange f3 pa3 b mt2 hover-bg-orange hover-white"
//     //       onClick={refreshRecords}
//     //     >
//     //       Refresh
//     //     </button>
//     //   </div>

//     //   <h2 className="f3 b white ">Add New Record</h2>
//     //   <div className="">
//     //     <h2 className="b white f3 ma2">
//     //       Company<label> (Set to default)</label>
//     //     </h2>

//     //     <input
//     //       // key={index}
//     //       className="br-pill b black"
//     //       type="text"
//     //       name="company"
//     //       defaultValue={names.company}
//     //       required="required"
//     //       disabled
//     //       // placeholder="Enter a company..."
//     //       // placeholder={names.company}
//     //       onChange={handleAddFormChange}
//     //     />
//     //     <h2 className="b white f3 ma2">Farmer ID</h2>

//     //     <input
//     //       // key={index}
//     //       className="br-pill b black tl"
//     //       type="text"
//     //       name="farmerid"
//     //       defaultValue={names.farmerid}
//     //       // required="required"
//     //       placeholder="Enter Farmer ID"
//     //       // placeholder={names.company}
//     //       onChange={handleAddFormChange}
//     //     />

//     //     <label
//     //       className=" br-pill bg-white orange f4  b pa2 hover-bg-orange hover-white"
//     //       onClick={handleLookupFarmerID}
//     //     >
//     //       Lookup ID
//     //     </label>
//     //     {foundFarmer ? (
//     //       <div className="br-pill bg-white w-25">
//     //         <label onClick={clearFoundFarmer} className="dt green f3 b  pa2">
//     //           {foundFarmer}
//     //         </label>
//     //       </div>
//     //     ) : null}
//     //     <div>
//     //       <h2 className="b white f3 ma2">
//     //         <b className="b white f3 ma2">First Name</b>
//     //       </h2>

//     //       <input
//     //         // ref={firstnameref}
//     //         className=" w-100 w-70-l tl  br-pill"
//     //         placeholder="First Name"
//     //         type="text"
//     //         name="firstName"
//     //         // value={addFormData.firstName}
//     //         onChange={handleAddFormChange}
//     //       />
//     //     </div>
//     //     <div>
//     //       <h2 className="b white f3 ma2">
//     //         <b className="b white f3 ma2">Last Name</b>
//     //       </h2>
//     //       <input
//     //         // ref={lastnameref}
//     //         className="w-100 w-70-l tl  br-pill"
//     //         placeholder="Last Name"
//     //         name="lastName"
//     //         type="text"
//     //         // value={addFormData.lastName}
//     //         onChange={handleAddFormChange}
//     //       />
//     //     </div>
//     //     <select
//     //       className="rounded pa2 ma2 f4 bg-white tracked br-pill w-25-l w-25-m"
//     //       value={names.producttype}
//     //       onChange={onProducttypeChange}
//     //       name="producttype"
//     //     >
//     //       {options.map((option) => (
//     //         <option key={option.value} value={option.value}>
//     //           {option.text}
//     //         </option>
//     //       ))}
//     //     </select>
//     //     <input
//     //       className="br-pill"
//     //       type="number"
//     //       name="weight"
//     //       placeholder="Enter weight (Kgs)"
//     //       onChange={handleAddFormChange}
//     //     />
//     //     {isLoadingAdd ? (
//     //       <div className="dib pa3">
//     //         <Circles type="Oval" color="#000080" height={30} width={40} />
//     //       </div>
//     //     ) : null}
//     //     <label
//     //       className=" br-pill bg-white orange f4  b pa2 hover-bg-orange hover-white"
//     //       onClick={handleAddFormSubmit}
//     //     >
//     //       Add
//     //     </label>
//     //     {successAdd ? (
//     //       <div className="br-pill bg-white w-25">
//     //         <label className="dt green f3 b  pa2">{successAdd}</label>
//     //       </div>
//     //     ) : null}
//     //     {foundErrAdd ? (
//     //       <label className="dt red f3 b  pb2">{foundErrAdd}</label>
//     //     ) : null}
//     //     <div className="bg-white shadow-3  pa2 br4">
//     //       <label className="f3 b black ">Note:</label>
//     //       <label className="f3 b black">
//     //         You can only add or edit a record for a farmer that belongs to your
//     //         designated company.
//     //       </label>
//     //     </div>
//     //   </div>
//     // </div>

//     // with improvements
//     <div className="records-app-container center mt6  ">


//       <div className="dib-l ">
//              {isLoading ? (
//         <div className="db mb2">
//           <Circles type="Oval" color="#000080" height={40} width={80} />
//         </div>
//       ) : null} 
//         <div className="controlContainer center d-grid bg-white  br4 shadow-3 w-100">
//            <div>
//             <h1 className="f2 b gold ma2 pa2">Hi, welcome back.</h1>
            
//             <RecordsDashboardClerk/>
           
//           </div>
//           <div className="grid-item  ">
//             <input
//               type="text"
//               className="searchInput "
//               placeholder="Search farmer Record"
//               onChange={onSearchChange}
//             />


//             <label className="pa1 hover-bg-transparent" onClick={searchRecords}>
//               <i className="fas fa-search f2 hover-gold orange"></i>
//               <span className=""></span>
//             </label>
//           </div>
//           <div className="grid-item ">
//             <label className="f3  ">
//               Showing <b>1-50</b> of <b> {contacts.length} </b>Entries
//             </label>
//             {/* <button
//               className=" br-pill bw0 ml2 bg-white orange f4  b pa2 hover-bg-orange hover-white"
//               type="submit"
//               onClick={handleAddFormSubmit}
//             >
//               back
//             </button> */}
//             {/* <button
//               // className=" br-pill bw0 ml2 bg-white orange f4  b pa2 hover-bg-orange hover-white"
//               className=" fas fa-caret-left f2 hover-gold"
//               type="submit"
//               onClick={handleAddFormSubmit}
//             >
//               next
//             </button> */}
//             <label className="pa3 hover-bg-transparent" onClick={handlePagePrevious}>
//               <i className="fas fa-caret-left f2 hover-gold"></i>
//               <span className=""></span>
//             </label>
//             <label className="pa3 hover-bg-transparent" onClick={handlePageNext}>
//               <i className="fas fa-caret-right f2 hover-gold"></i>
//               <span className=""></span>
//             </label>
//             <label className="pa3 hover-bg-transparent" onClick={handleDownloadTable}>
//               <i className="fas fa-download f2 hover-gold"></i>
//               <span className=""></span>
//             </label>
//              <label
//               className="br-pill bg-orange white f5 b pa2 hover-bg-orange hover-white pointer dib"
//               onClick={scrollToFirstName}
//             >
//               Add
//             </label>
//           </div>
//         </div>

//       </div>
//       <form onSubmit={handleEditFormSubmit}>
//         <table>
//           <thead  >
//             <tr >
//               <th className="bg-gold">ID</th>
//               <th className="bg-gold">Farmer ID</th>
//               <th className="bg-gold">Product Type</th>
//               <th className="bg-gold">Weight</th>
//               <th className="bg-gold">Company</th>
//               <th className="bg-gold">Full Name</th>

//               <th className="bg-gold">Recorded</th>
//               <th className="bg-gold">Edit records</th>
//             </tr>
//           </thead>
//           <tbody>
//             {contacts.map((contact) => (
//               <Fragment key={contact.id}>
//                 {editContactId === contact.id ? (
//                   <EditableRow
//                     handleEditFormSubmit={handleEditFormSubmit}
//                     isLoadingSave={isLoadingSave}
//                     editFormData={editFormData}
//                     handleEditFormChange={handleEditFormChange}
//                     handleCancelClick={handleCancelClick}
//                     handleDownloadRow={handleDownloadRow}
//                   />
//                 ) : (
//                   <ReadOnlyRow
//                     contact={contact}
//                     handleEditClick={handleEditClick}
//                     handleDeleteClick={handleDeleteClick}
//                     handleDownloadRow={handleDownloadRow}

//                   />
//                 )}
//               </Fragment>
//             ))}
//           </tbody>
//         </table>
//       </form>
//       <div>
//         {success && <p className="green f2 b">{success}</p>}
//         {foundErrAdd && <p className="red f2 b">{foundErrAdd}</p>}

//         {/* {foundErr ? <label className="dt red  pb2">{foundErr}</label> : null} */}

//         <button
//           className="ml2 br-pill bg-white orange f3 pa3 b mt2 hover-bg-orange hover-white"
//           onClick={refreshRecords}
//         >
//           Refresh
//         </button>
//       </div>


//       {/* improved */}
//    {/* improved */}
//       <div className="recordsdiv">
//         <h2 className="f3 b gold">Add New Record</h2>

//         <div className="form-grid">
//           {/* Company selection */}
//           <div>
//             <label className="b f5 db mb2">Choose the company</label>
//             <select
//               className=""
//               // value={names.company}
//               onChange={onCompanyChange}
//                             ref={companyRef}
//               value={addFormData.company}
//             >
//               <option value="">-- Choose a company --</option>
//               {(Array.isArray(companiesList) ? companiesList : []).map((company, idx) => (
//                 <option key={idx} value={company.name}>{company.name}</option>
//               ))}
//             </select>
//           </div>

//           {/* Farmer ID + Lookup */}
//           <div>
//             <label className="b f5 db mb2">Farmer ID</label>
//             <input
//               type="text"
//               name="farmerid"
//               // defaultValue={names.farmerid}
//               value={addFormData.farmerid}
//               placeholder="Enter Farmer ID"
//               onChange={handleAddFormChange}
//             />
//             <button
//               type="button"
//               className={`lookup-btn ${isLoadingAdd ? "lookup-btn-disabled" : ""
//                 }`}
//               onClick={handleLookupFarmerID}
//               disabled={isLoadingAdd}
//             >
//               {isLoadingAdd ? (
//                 <>
//                   <i className="fas fa-spinner fa-spin mr2"></i>
//                   Looking up...
//                 </>
//               ) : (
//                 <>
//                   <i className="fas fa-search mr2"></i>
//                   Lookup Farmer
//                 </>
//               )}
//             </button>
//           </div>

//           {/* Optional lookup result */}
//           {/* {foundFarmer && (
//       <div className="br-pill bg-light-green pa2">
//         <label onClick={clearFoundFarmer} className="f6 b green">
//           {foundFarmer}
//         </label>
//       </div>
//     )} */}

//           {foundFarmer && (
//             <div
//               className={
//                 foundFarmer.success
//                   ? "lookup-card-success"
//                   : "lookup-card-error"
//               }
//             >
//               {/* dismiss button */}
//               <button
//                 type="button"
//                 className="lookup-close-btn"
//                 onClick={clearFoundFarmer}
//               >
//                 ×
//               </button>

//               {foundFarmer.success ? (
//                 <>
//                   <div className="lookup-header">
//                     <div className="lookup-icon-success">
//                       <i className="fas fa-check-circle"></i>
//                     </div>

//                     <div>
//                       <div className="lookup-title">
//                         {foundFarmer.message}
//                       </div>

//                       <div className="lookup-subtitle">
//                         Farmer found successfully
//                       </div>
//                     </div>
//                   </div>

//                   <div className="lookup-details">
//                     <div className="lookup-row">
//                       <span className="lookup-label">
//                         Farmer Name
//                       </span>

//                       <span className="lookup-value">
//                         {foundFarmer.data.fullname}
//                       </span>
//                     </div>

//                     <div className="lookup-row">
//                       <span className="lookup-label">
//                         Farmer ID
//                       </span>

//                       <span className="lookup-value">
//                         {foundFarmer.data.farmerid}
//                       </span>
//                     </div>
//                     <div className="lookup-row">
//                       <span className="lookup-label">
//                      Company
//                       </span>

//                       <span className="lookup-value">
//                         {foundFarmer.data.company}
//                       </span>
//                     </div>
//                   </div>

//                   <div className="lookup-actions">
//                     <button
//                       type="button"
//                       className="lookup-autofill-btn"
//                       onClick={() => {
//                         handleAutofillNames();
//                         clearFoundFarmer();
//                       }}
//                     >
//                       <i className="fas fa-magic mr2"></i>
//                       Autofill Names
//                     </button>
//                   </div>
//                 </>
//               ) : (
//                 <>
//                   <div className="lookup-header">
//                     <div className="lookup-icon-error">
//                       <i className="fas fa-times-circle"></i>
//                     </div>

//                     <div>
//                       <div className="lookup-title-error">
//                         {foundFarmer.error}
//                       </div>

//                       <div className="lookup-subtitle">
//                         No farmer record found
//                       </div>
//                     </div>
//                   </div>
//                 </>
//               )}
//             </div>
//           )}

//           {/* First Name */}
//           <div>
//             <label className="b f5 db mb2">First Name</label>
//             <input
//               type="text"
//               name="firstName"
//               placeholder="First Name"
//               ref={firtNameRef}
//               value={addFormData.firstName}
//               onChange={handleAddFormChange}
//             />
//           </div>

//           {/* Last Name */}
//           <div>
//             <label className="b f5 db mb2">Last Name</label>
//             <input
//               type="text"
//               name="lastName"
//               placeholder="Last Name"
//               value={addFormData.lastName}
//               ref={lastNameRef}
//               onChange={handleAddFormChange}
//             />
//           </div>

//           {/* Product type */}
//           <div>
//             <label className="b f5 db mb2">Product Type</label>
//             <select
//               className=""
//               value={names.producttype}
//               name="producttype"
//               onChange={onProducttypeChange}
//             >
//               {options.map((option) => (
//                 <option key={option.value} value={option.value}>
//                   {option.text}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Weight */}
//           <div>
//             <label className="b f5 db mb2">Weight (kg)</label>
//             <input
//               type="number"
//               name="weight"
//               value={addFormData.weight}
//               placeholder="Enter weight"
//               onChange={handleAddFormChange}
//             />
//           </div>
//         </div>

//         {/* Button + loading */}
//         <div className="mt3">
//           {isLoadingAdd ? (
//             <div className="dib pa3">
//               <Circles type="Oval" color="#000080" height={30} width={40} />
//             </div>
//           ) : (
//             <label
//               className="br-pill bg-orange white f5 b pa2 hover-bg-orange hover-white pointer dib"
//               onClick={handleAddFormSubmit}
//             >
//               Add
//             </label>
//           )}
//         </div>

//         {/* Success/Error states */}
//         {/* {successAdd && (
//     <div className="br-pill bg-light-green pa2 mt2">
//       <label className="f5 green b">{successAdd}</label>
//     </div>
//   )} */}

//         {successAdd && (
//           <div className="br-pill bg-light-green pa2 mt2">
//             <label className="f5 green b">
//               {typeof successAdd === "string"
//                 ? successAdd
//                 : successAdd.message}
//             </label>
//           </div>
//         )}

//         {foundErrAdd && (
//           <label className="f5 red b db mt2">{foundErrAdd}</label>
//         )}

//         {/* Footer note */}
//         <div className="bg-white shadow-3 pa3 br4 mt3">
//           <label className="f5 b black db mb1">Note:</label>
//           <span className="f5 black">
//             You can only add or edit a record for a farmer that belongs to your designated company.
//           </span>
//         </div>
//       </div>


//     </div>
//   );
// };

// export default Records;



// new with improvements
import React, { useState, Fragment, useEffect, useRef } from "react";

import "./style.css";
import data from "./mock-data.json";
import ReadOnlyRow from "./ReadOnlyRow";
import EditableRow from "./EditableRow";

import Cookies from "js-cookie";

import { Circles } from "react-loader-spinner";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import RecordsDashboardClerk from "./RecordsDashboardClerk";

//receipt component
import Receipt from "../../twAdmin/twRecords/receipts/Receipt";

import ClassPrinter from "../../twAdmin/twRecords/receipts/ClassPrinter";

//pdf creator
import jsPDF from "jspdf";
// import "jspdf-autotable";

// import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import { useSelector } from "react-redux";
import { fetchCompanies } from "../../../redux/companySlice";
import { useDispatch } from "react-redux";

import RecordsFilterBar from "./RecordsFilterBar";
import RecordsSummary from "./RecordsSummary";
import RecordsFilteredView from "./RecordsFilteredView";

const Records = () => {
  const options = [
    { value: "", text: "-- choose product type --" },
    { value: "coffee", text: "coffee" },
    { value: "tea leaves", text: "tea leaves" },
    { value: "milk", text: "milk" },
  ];

  //store select company values in an array
  const companies = [
    { value: "", text: "-- select company--" },
    { value: "Terraweb", text: "Terraweb" },
    { value: "Gatamura Dairy", text: "Gatamura Dairy" },
    { value: "Mbuuni Coffee", text: "Mbuuni Coffee" },
    { value: "Kanyua Tea", text: "Kanyua Tea" },
  ];

  const [names, setNames] = useState({
    producttype: options[0].value,
    company: companies[0].value,
  });

  const [profile, setProfile] = useState(null);

  const [foundUsers, setFoundUsers] = useState();

  const [contacts, setContacts] = useState(data);
  const [addFormData, setAddFormData] = useState({
    id: "",
    fullname: "",
    farmerid: "",
    firstName: "",
    lastName: "",
    producttype: "",
    daterecorded: "",
    company: "",
    weight: "",
  });

  const [editFormData, setEditFormData] = useState({
    id: "",
    fullname: "",
    producttype: "",
    daterecorded: "",
    companyname: "",
    weight: "",
  });


  //dispatch companies from the redux store
  const dispatch = useDispatch();
  //fetch companies using get

  const companiesList = useSelector((state) => state.companies?.list || []);

  useEffect(() => {
    dispatch(fetchCompanies());
  }, [dispatch]);


  const [editContactId, setEditContactId] = useState(null);

  //lookup farmer id and set state to show labe if found
  const [foundFarmer, setFoundFarmer] = useState(null);

  //display success info after successful registration
  const [success, setSuccess] = useState("");

  const [foundErr, setFoundErr] = useState(null);
  const [foundErrAdd, setFoundErrAdd] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [isLoadingAdd, setIsLoadingAdd] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(null);

  //when record is successfully added
  const [successAdd, setSuccessAdd] = useState(null);

  //analysis Constants
  const [totalRecords, settotalRecords] = useState(null);

  //search users in your company
  const [searchRecord, setSearchRecord] = useState("");

  const [deleteState, setDeleteState] = useState("");

  const [isLoadingDelete, setIsLoadingDelete] = useState(false);

  const [selectedRecords, setSelectedRecords] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [viewMode, setViewMode] = useState("all");
  // "all" | "approved" | "not_approved" | "monthly" | "yearly"

  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  const [currentPage, setCurrentPage] = useState(1);

  const recordsPerPage = 50;

  //clear inputs
  const usernameRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();

  //use ref to fill inputs or clear them
  const firtNameRef = useRef();
  const lastNameRef = useRef();
  const companyRef = useRef();





  //creating a fullname formatter here so that fullname data goes into the dataabase in the
  //form of firstname Lastname
  // Function to format the full name
  const formatFullName = (firstName, lastName) => {
    // Ensure the first letter of each name is capitalized
    const formattedFirstName =
      firstName.charAt(0).toUpperCase() + firstName.slice(1);
    const formattedLastName =
      lastName.charAt(0).toUpperCase() + lastName.slice(1);

    // Combine the formatted names into the full name
    const fullName = `${formattedFirstName} ${formattedLastName}`;

    return fullName;
  };

  //format the company to start with capital letter and remove white spaces
  // Function to format the company name
  const formatCompanyName = (input) => {
    // Remove leading and trailing white spaces
    const trimmedInput = input.trim();

    // Ensure the first letter is capitalized
    const formattedCompanyName =
      trimmedInput.charAt(0).toUpperCase() + trimmedInput.slice(1);

    return formattedCompanyName;
  };

  //handle product type input
  const onProducttypeChange = (event) => {
    // if (names.gender.length >= 1) {
    //   setFlag(1);
    // } else {
    //   setFlag(2);
    // }
    // Spreading "...state" ensures we don't "lose" fname,lname,email... etc
    setNames((names) => ({
      ...names,
      producttype: event.target.value,
    }));

    //update the form fields before updating
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData = { ...addFormData };
    newFormData[fieldName] = fieldValue;

    setAddFormData(newFormData);
  };

  useEffect(() => {
    //fetch records
    const fetchAll = () => {
      try {
        let adminCookie = Cookies.get("sessionidadmin");
        let userCookie = Cookies.get("sessioniduser");
        if (adminCookie.length >= 8 || userCookie.length >= 8) {
          setIsLoading(true);

          setTimeout(() => {
            fetch("https://api.terraweb.africa/getDailyRecords", {

              method: "post",
              headers: { "Content-Type": "application/JSON" },
              body: JSON.stringify({
                adminid: adminCookie,
                userid: userCookie,
              }),
            })
              .then(function (response) {
                if (response.status === 400) {
                  throw Error("Wrong credentials");
                }
                if (response === 500) {
                  throw Error("Could not complete request because of an error");
                }

                return response.json();
              })
              .then((user) => {
                if (user[0].id >= 1) {
                  setFoundErr(null);

                  setIsLoading(null);
                  setContacts(user);
                  // loadAnalysis(user);

                  //load data
                } else {
                  //dont load

                  setFoundErr(null);
                  setIsLoading(null);
                }
              })
              .catch((err) => {
                // setFoundErr(err.message);
                setIsLoading(null);
                // setFlag(1);
              });
          }, 2000);
        } else {
          setIsLoading(null);
        }
      } catch (error) { }
    };

    //load profile
    const fetchProfile = () => {
      let adminCookie = "";
      adminCookie = Cookies.get("sessionidadmin");

      if (adminCookie.length >= 1) {
        setIsLoading(true);
        setTimeout(() => {
          fetch("https://api.terraweb.africa/loadProfileClerk", {
            method: "post",
            headers: { "Content-Type": "application/JSON" },
            body: JSON.stringify({
              adminid: adminCookie,

            }),
          })
            .then(function (response) {
              if (response.status === 400) {
                throw Error("Wrong credentials");
              }
              if (response === 500) {
                throw Error("Could not complete request because of an error");
              }

              return response.json();
            })
            .then((res) => {

              if (res.success) {

                setProfile(res.data);

                setFoundErrAdd(null);
                setIsLoading(false);

                setSuccess(null);
                setDeleteState(null);

                setNames((prev) => ({
                  ...prev,
                  company: res.data.company,
                }));

                setAddFormData((prev) => ({
                  ...prev,
                  company: res.data.company,
                }));

              } else {

                setFoundErrAdd("Unable to load profile");
                setIsLoading(false);

              }

            })
            .catch((err) => {
              // setFoundErr(err.message);
              setIsLoading(null);
              // setFlag(1);
            });
        }, 150);
      } else {
        setIsLoading(null);
      }
    };

    fetchAll();
    fetchProfile();
  }, []);

  // timer for success and error message
  // Success/Error auto-hide after 8 seconds
  useEffect(() => {
    if (successAdd || foundErrAdd) {
      const timer = setTimeout(() => {
        setSuccessAdd("");
        setFoundErrAdd("");
      }, 8000);

      return () => clearTimeout(timer); // cleanup
    }
  }, [successAdd, foundErrAdd]);

  //load analysis
  const loadAnalysis = (datamap) => { };

  //search records
  const searchRecords = () => {
    // setContacts(null);
    //fetch cookie
    let adminCookie = Cookies.get("sessionidadmin");
    if (adminCookie.length >= 1) {
      setIsLoading(true);

      setTimeout(() => {
        fetch("https://api.terraweb.africa/searchRecords", {
          method: "post",
          headers: { "Content-Type": "application/JSON" },
          body: JSON.stringify({
            adminid: adminCookie,

            fullname: searchRecord,

            userid: searchRecord,
          }),
        })
          .then(function (response) {
            if (response.status === 400) {
              throw Error("Wrong credentials");
            }
            if (response === 500) {
              throw Error("Could not complete request because of an error");
            }

            return response.json();
          })
          .then((user) => {
            if (user[0].id >= 1) {
              setFoundErr(null);
              setFoundErrAdd(null);
              setDeleteState(null);

              setIsLoading(null);
              setContacts(user);
              loadAnalysis(user);

              //load data
            } else {
              //dont load

              setFoundErr(null);
              setFoundErrAdd(null);
              setIsLoading(null);
              setDeleteState(null);
            }
          })
          .catch((err) => {
            // setFoundErr(err.message);
            setIsLoading(null);
            // setFlag(1);
          });
      }, 1500);
    } else {
      setIsLoading(null);
    }
  };

  //handle search user
  const onSearchChange = (event) => {
    event.preventDefault();
    setSearchRecord(event.target.value);
  };

  //fetch users
  const fetchRecords = () => {
    try {
      let adminCookie = Cookies.get("sessionidadmin");
      let userCookie = Cookies.get("sessioniduser");
      if (adminCookie.length >= 8 || userCookie.length >= 8) {
        setIsLoading(true);

        setTimeout(() => {
          fetch("https://api.terraweb.africa/getDailyRecords", {

            method: "post",
            headers: { "Content-Type": "application/JSON" },
            body: JSON.stringify({
              adminid: adminCookie,
              userid: userCookie,
            }),
          })
            .then(function (response) {
              if (response.status === 400) {
                throw Error("Wrong credentials");
              }
              if (response === 500) {
                throw Error("Could not complete request because of an error");
              }

              return response.json();
            })
            .then((user) => {
              if (user[0].id >= 1) {
                setFoundErr(null);

                setIsLoading(null);
                setContacts(user);
                // loadAnalysis(user);

                //load data
              } else {
                //dont load

                setFoundErr(null);
                setIsLoading(null);
              }
            })
            .catch((err) => {
              // setFoundErr(err.message);
              setIsLoading(null);
              // setFlag(1);
            });
        }, 2000);
      } else {
        setIsLoading(null);
      }
    } catch (error) { }
  };

  //load profile
  const fetchProfile = () => {
    let adminCookie = "";
    adminCookie = Cookies.get("sessionidadmin");
    ;
    if (adminCookie.length >= 1) {
      setIsLoading(true);
      setTimeout(() => {
        fetch("https://api.terraweb.africa/loadProfileClerk", {
          method: "post",
          headers: { "Content-Type": "application/JSON" },
          body: JSON.stringify({
            adminid: adminCookie,

          }),
        })
          .then(function (response) {
            if (response.status === 400) {
              throw Error("Wrong credentials");
            }
            if (response === 500) {
              throw Error("Could not complete request because of an error");
            }

            return response.json();
          })
          .then((user) => {
            if (user[0].username.length >= 1) {
              //load data

              setFoundErrAdd(null);

              setIsLoading(null);
              setContacts(user);

              setSuccess(null);
              setDeleteState(null);

              //store a name after load to display in the title of the users table
              setNames((names) => ({
                ...names,
                company: user[0].company,
              }));
            } else {
              //dont load

              setFoundErrAdd(null);
              setFoundErr(null);
              setIsLoading(null);
              setDeleteState(null);
            }
          })
          .catch((err) => {
            // setFoundErr(err.message);
            setIsLoading(null);
            // setFlag(1);
          });
      }, 150);
    } else {
      setIsLoading(null);
    }
  };

  //check if user exists when full name is typed out
  const fetchUsers = () => { };



  //temp handle add form change
  const handleAddFormChange = (event) => {
    event.preventDefault();

    setSuccess(null);
    setFoundErrAdd(null);

    const fieldName = event.target.getAttribute("name");
    let fieldValue = event.target.value;

    // Check if the field name is "company" and apply formatting if needed
    if (fieldName === "company") {
      // Ensure the first letter is capitalized
      fieldValue = fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1);

      // Remove trailing white spaces
      fieldValue = fieldValue.trim();
      setAddFormData((prevState) => ({
        ...prevState,
        company: fieldValue,
      }));
    } else if (fieldName === "firstName") {
      // Handle input changes for first name
      if (/^[A-Za-z]+$/.test(fieldValue) || fieldValue === "") {
        const fullName = formatFullName(fieldValue, addFormData.firstName);

        setAddFormData((prevState) => ({
          ...prevState,
          firstName: fieldValue,
          fullname: fullName,
        }));
      }
    } else if (fieldName === "lastName") {
      // Handle input changes for last name
      if (/^[A-Za-z]+$/.test(fieldValue) || fieldValue === "") {
        const fullName = formatFullName(addFormData.firstName, fieldValue);
        setAddFormData((prevState) => ({
          ...prevState,
          lastName: fieldValue,
          fullname: fullName,
        }));
      }
    } else {
      const newFormData = { ...addFormData };
      newFormData[fieldName] = fieldValue;

      setAddFormData(newFormData);
    }
  };

  //handle company input
  const onCompanyChange = (event) => {
    if (names.company.length >= 3) {
      //   setFlag(1);
    } else {
      //   setFlag(2);
    }
    // Spreading "...state" ensures we don't "lose" fname,lname,email... etc
    setNames((names) => ({
      ...names,
      company: event.target.value,
    }));
    setAddFormData((prev) => ({
      ...prev,
      company: event.target.value,

    }));
  };

  const handleEditFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");

    const fieldValue = event.target.value;

    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;

    setEditFormData(newFormData);
  };

  //refresh after add records
  const refreshRecords = () => {
    fetchRecords();
  };


  // const handleAddFormSubmit = (event) => {

  //   event.preventDefault();

  //   setFoundErrAdd("");
  //   setSuccessAdd("");

  //   const newContact = {
  //     farmerid: addFormData.farmerid,
  //     companyname: addFormData.company,
  //     producttype: addFormData.producttype,
  //     weight: addFormData.weight,
  //     fullname: addFormData.fullname,
  //   };

  //   if (
  //     newContact.companyname.length >= 3 &&
  //     newContact.producttype.length >= 3 &&
  //     newContact.fullname.length >= 3 &&
  //     String(newContact.weight).length >= 1
  //   ) {
  //     //send add record request
  //     let adminCookie = Cookies.get("sessionidadmin");

  //     if (adminCookie && adminCookie.length >= 4) {
  //       setIsLoadingAdd(true);

  //       setTimeout(() => {
  //         fetch("https://api.terraweb.africa/addnewrecord", {
  //           method: "post",
  //           headers: { "Content-Type": "application/JSON" },
  //           body: JSON.stringify({
  //             adminid: adminCookie,
  //             farmerid: newContact.farmerid,
  //             producttype: newContact.producttype,
  //             weight: newContact.weight,
  //             fullname: newContact.fullname,
  //             companyname: newContact.companyname,
  //           }),
  //         })
  //           .then(async function (response) {
  //             const data = await response.json();

  //             // handle backend errors properly
  //             if (!response.ok) {
  //               throw data;
  //             }

  //             return data;
  //           })
  //           .then((data) => {
  //             setFoundErrAdd(null);
  //             setIsLoadingAdd(null);

  //             // success message from backend
  //             setSuccessAdd(
  //               data.message || "Record added successfully"
  //             );

  //             // refresh records
  //             refreshRecords();

  //             // optional clear form
  //             setAddFormData({
  //               id: "",
  //               fullname: "",
  //               farmerid: "",
  //               firstName: "",
  //               lastName: "",
  //               producttype: "",
  //               daterecorded: "",
  //               company: "",
  //               weight: "",
  //             });
  //           })
  //           .catch((err) => {
  //             console.log("BACKEND ERROR:", err);

  //             if (err.missingFields) {
  //               setFoundErrAdd(
  //                 `Missing fields: ${err.missingFields.join(
  //                   ", "
  //                 )}`
  //               );
  //             } else if (err.message) {
  //               setFoundErrAdd(err.message);
  //             } else {
  //               setFoundErrAdd(
  //                 "An unexpected error occurred"
  //               );
  //             }

  //             setIsLoadingAdd(null);
  //           });
  //       }, 1000);
  //     } else {
  //       setFoundErrAdd(
  //         "Session expired. Please login again."
  //       );
  //       setIsLoadingAdd(null);
  //     }
  //   } else {
  //     setFoundErrAdd(
  //       "Please fill all required fields correctly."
  //     );
  //   }
  // };


  const handleAddFormSubmit = (event) => {
  event.preventDefault();

  setFoundErrAdd("");
  setSuccessAdd("");

  const newContact = {
    farmerid: addFormData.farmerid,
    companyname: addFormData.company,
    producttype: addFormData.producttype,
    weight: addFormData.weight,
    fullname: addFormData.fullname,
  };

  if (
    newContact.companyname.length >= 3 &&
    newContact.producttype.length >= 3 &&
    newContact.fullname.length >= 3 &&
    String(newContact.weight).length >= 1
  ) {
    let adminCookie = Cookies.get("sessionidadmin");

    if (adminCookie && adminCookie.length >= 4) {
      setIsLoadingAdd(true);

      fetch("https://api.terraweb.africa/addnewrecord", {
        method: "post",
        headers: { "Content-Type": "application/JSON" },
        body: JSON.stringify({
          adminid: adminCookie,
          farmerid: newContact.farmerid,
          producttype: newContact.producttype,
          weight: newContact.weight,
          fullname: newContact.fullname,
          companyname: newContact.companyname,
        }),
      })
        .then(async (response) => {
          const data = await response.json();

          if (!response.ok) {
            throw data;
          }

          return data;
        })
        .then((data) => {
          setSuccessAdd(data.message || "Record added successfully");

          // stop loader
          setIsLoadingAdd(false);

          // reset form
          setAddFormData({
            id: "",
            fullname: "",
            farmerid: "",
            firstName: "",
            lastName: "",
            producttype: "",
            daterecorded: "",
            company: "",
            weight: "",
          });

          // refresh records (no delay needed)
          refreshRecords();
        })
        .catch((err) => {
          console.log("BACKEND ERROR:", err);

          setIsLoadingAdd(false);

          if (err.missingFields) {
            setFoundErrAdd(
              `Missing fields: ${err.missingFields.join(", ")}`
            );
          } else if (err.message) {
            setFoundErrAdd(err.message);
          } else {
            setFoundErrAdd("An unexpected error occurred");
          }
        });
    } else {
      setFoundErrAdd("Session expired. Please login again.");
    }
  } else {
    setFoundErrAdd("Please fill all required fields correctly.");
  }
};

  const handleEditFormSubmit = (event) => {
    event.preventDefault();

    const editedContact = {
      id: editFormData.id,
      companyname: editFormData.companyname,
      producttype: editFormData.producttype,
      weight: editFormData.weight,
      fullname: editFormData.fullname,
      daterecorded: editFormData.daterecorded,

      approved_status: editFormData.approved_status,
      date_approved: editFormData.date_approved
    };

    const newContacts = [...contacts];

    const index = contacts.findIndex(
      (contact) => contact.id === editContactId
    );

    newContacts[index] = editedContact;

    const adminCookie = Cookies.get("sessionidadmin");

    if (adminCookie && adminCookie.length >= 1) {
      setIsLoadingSave(true);

      fetch("https://api.terraweb.africa/updateRecord", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          id: newContacts[index].id,
          adminid: adminCookie,

          fullname: newContacts[index].fullname,
          companyname: newContacts[index].companyname,
          producttype: newContacts[index].producttype,
          weight: newContacts[index].weight,

          approved_status: newContacts[index].approved_status,
          // date_approved: newContacts[index].date_approved,

          farmerid: contacts[index].farmerid,
        }),
      })
        .then((response) => response.json())
        .then((resData) => {
          if (resData.success) {
            setFoundErrAdd(null);
            setSuccess(
              resData.message || "Record updated successfully"
            );

            setEditContactId(null);
            refreshRecords();
          } else {
            setSuccess(null);
            setFoundErrAdd(
              resData.error || "Update failed"
            );
          }

          setIsLoadingSave(false);
        })
        .catch((err) => {
          setSuccess(null);
          setFoundErrAdd(
            err.message || "Unexpected error occurred"
          );
          setIsLoadingSave(false);
        });
    } else {
      setFoundErrAdd(
        "Session expired or invalid session ID."
      );
      setIsLoadingSave(false);
    }
  };

  const handleEditClick = (event, contact) => {
    event.preventDefault();
    setEditContactId(contact.id);

    const formValues = {
      id: contact.id,
      companyname: contact.companyname,
      producttype: contact.producttype,
      weight: contact.weight,
      fullname: contact.fullname,
      daterecorded: contact.daterecorded,
    };

    setEditFormData(formValues);
  };

  const handleCancelClick = () => {
    setEditContactId(null);
  };

  //confirm delete record
  const onDeleteYes = (id) => {
    let adminCookie = Cookies.get("sessionidadmin");
    if (adminCookie.length >= 1) {
      fetch("https://api.terraweb.africa/deleterecord", {
        method: "post",
        headers: { "Content-Type": "application/JSON" },
        body: JSON.stringify({
          adminid: adminCookie,

          id: id,
        }),
      })
        .then(function (response) {
          if (response.status === 400) {
            throw Error("An error occurred, during delete.");
          }
          if (response === 500) {
            throw Error("Could not complete request because of an error");
          }

          return response.json();
        })
        .then((user) => {
          if (user) {
            refreshRecords();
          } else {
            //dont load
          }
        })
        .catch((err) => {
          // setFlag(1);
        });
    } else {
    }
  };

  const handleDeleteClick = (contactemail) => {
    //delete alert
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="deletediv bg-white br3 bb b--black-10  gold pa2 w-100 shadow-5 center ">
            <h1>Confirm Delete Record</h1>
            <p className="f3 black">Sure you want to delete this user record with ID: {contactemail}?</p>
            <p className="b red f4">
              Note that this cannot be <b className="red f3">UNDONE</b>
            </p>
            <label
              className="dib w3 tc pa2 f3 ma2 white br-pill bg-red hover-bg-white hover-black "
              onClick={onClose}
            >
              No
            </label>
            <label
              className="dib w6 f5 fr tc pa3 white br-pill bg-blue hover-bg-red hover-white"
              onClick={() => {
                onDeleteYes(contactemail);
                onClose();
              }}
            >
              Yes, Delete it!
            </label>
          </div>
        );
      },
    });
  };

  //bulk deletes
  const handleDeleteSelected = () => {
    if (selectedRecords.length === 0) {
      setFoundErrAdd("Please select at least one record.");
      return;
    }

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="deletediv bg-white br3 shadow-5 pa4">
            <h2 className="red tc">
              Delete {selectedRecords.length} Records?
            </h2>

            <p className="black f4 tc">
              This action cannot be undone.
            </p>

            <div className="tc mt4">

              <button
                className="mr3 ph4 pv2 br-pill bn bg-light-gray pointer"
                onClick={onClose}
              >
                Cancel
              </button>

              <button
                className="ph4 pv2 br-pill bn bg-red white pointer"
                onClick={async () => {
                  await onBulkDeleteYes();
                  onClose();
                }}
              >
                Delete Selected
              </button>

            </div>
          </div>
        );
      },
    });
  };

  const onBulkDeleteYes = async () => {
    try {
      setIsLoadingDelete(true);

      const adminCookie = Cookies.get("sessionidadmin");

      if (!adminCookie) {
        setFoundErrAdd("Admin session expired.");
        return;
      }

      await Promise.all(
        selectedRecords.map((recordId) =>
          fetch("https://api.terraweb.africa/deleterecord", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              adminid: adminCookie,
              id: recordId,
            }),
          })
        )
      );

      setSuccess(
        `${selectedRecords.length} records deleted successfully`
      );

      setSelectedRecords([]);

      refreshRecords();

    } catch (err) {
      setFoundErrAdd(
        err.message || "Failed to delete selected records"
      );
    } finally {
      setIsLoadingDelete(false);
    }
  };


  const handleAutofillNames = () => {
    if (!foundFarmer?.success) return;

    const fullname = foundFarmer.data.fullname || "";

    const names = fullname.split(" ");

    const firstName = names[0] || "";
    const lastName = names.slice(1).join(" ") || "";
    const company = foundFarmer.data.company

    setAddFormData((prev) => ({
      ...prev,
      firstName,
      lastName,
      fullname, company
    }));

    clearFoundFarmer();
  };


  // Function to clear the foundFarmer state
  const clearFoundFarmer = () => {
    setFoundFarmer(null); // You can set it to null or an empty object, depending on your use case
  };


  const handleLookupFarmerID = async (event) => {
    event.preventDefault();

    setFoundErrAdd("");
    setFoundFarmer(null);

    try {
      const farmerid = addFormData.farmerid?.trim();

      if (!farmerid) {
        setFoundErrAdd("Enter farmer ID");
        return;
      }

      setIsLoadingAdd(true);

      const adminCookie = Cookies.get("sessionidadmin");

      const response = await fetch(
        "https://api.terraweb.africa/lookupFarmerProfile",
        {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            adminid: adminCookie,
            farmerid,
          }),
        }
      );

      const data = await response.json();

      setIsLoadingAdd(false);

      setFoundFarmer(data);

    } catch (err) {
      setIsLoadingAdd(false);

      setFoundFarmer({
        success: false,
        error: "Could not lookup farmer.",
      });
    }
  };

  //handle download per row receipt
  const handleDownloadRow = (contact) => {
    handlePrint(contact)

  }
  const getReceiptText = (data) => {
    // let adminCookie = Cookies.get("sessionidadmin");

    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-KE", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    const formattedTime = now.toLocaleTimeString("en-KE");
    const user = "TWAdmin"

    const printedBy = user?.name || "Admin";

    return `
    Terraweb.africa                 
    --------------------------------------------------------------------
    Printed On: ${formattedDate} at ${formattedTime}
    Printed By: ${printedBy}
    --------------------------------------------------------------------
    Company: ${data.companyname}
    --------------------------------------------------------------------
    Receipt ID: ${data.id}
    Username: ${data.fullname}
    Farmer ID: ${data.farmerid}
    Weight: ${data.weight}
    ---------------------------------------------------------------------
    Total: ${data.weight}
    ---------------------------------------------------------------------
    Thank you for choosing Our Company.
    We Value You.
    `;
  };

  const handlePrint = (contact) => {
    const receiptText = getReceiptText(contact);
    const printer = new ClassPrinter();
    printer.print(receiptText);
  };

  const getCompanyInitials = (name = "") => {
  return name
    .split(" ")
    .map(w => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};
  //handle download table

  const handleDownloadTable = async () => {
  const doc = new jsPDF();

  // const currentDate = new Date().toLocaleString();
  const currentDate = new Date().toISOString().replace("T", " ").split(".")[0];

  // Example: derive company info (adjust if you already store profile)
  const companyName = contacts?.[0]?.companyname || "Terraweb";
  const initials = getCompanyInitials(companyName);

  const getBase64ImageFromUrl = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

  // const favicon = "/favicon.ico"; // or base64 version (recommended)
  // const faviconBase64 = "data:image/png;base64,...."; // your converted icon

  const faviconBase64 = await getBase64ImageFromUrl("/img/LOGO-FAVCON.png");
  // =========================
  // HEADER (Professional)
  // =========================

  // Company badge (2-letter "SVG-like" circle)
const badgeX = 180;
const badgeY = 5;
const badgeSize = 16;

doc.setFillColor(252, 156, 28);
doc.roundedRect(
  badgeX,
  badgeY,
  badgeSize,
  badgeSize,
  3,
  3,
  "F"
);

doc.setFont("helvetica", "bold");
doc.setFontSize(18);
doc.setTextColor(255, 255, 255);

const textWidth = doc.getTextWidth(initials);

doc.text(
  initials,
  badgeX + (badgeSize / 2) - (textWidth / 2),
  badgeY + 11
);

doc.setTextColor(0, 0, 0);

  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  // doc.text("Empowering farmers through technology", 14, 23);

  // Account Profile section
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  // doc.text("Account Profile:", 14, 32);

  doc.setFont("helvetica", "bold");
  doc.text(`Company: ${companyName}`, 14, 38);
  doc.text(`Generated: ${currentDate}`, 14, 44);

  // Account Information (expandable section)
  doc.setFont("helvetica", "bold");
  // doc.text("Account Information:", 14, 52);

  doc.setFont("helvetica", "normal");
  doc.text(`Total Records: ${contacts?.length || 0}`, 14, 58);

  // =========================
  // TABLE
  // =========================

  const tableColumn = [
    "ID",
    "Farmer ID",
    "Product Type",
    "Weight",
    "Company",
    "Full Name",
    "Added by",
    "Recorded Date",
  ];

  const tableRows =
    contacts?.map((contact) => [
      contact.id,
      contact.farmerid,
      contact.producttype,
      contact.weight,
      contact.companyname,
      contact.fullname,
      contact.added_by || "Admin", // ✅ NEW: clerk included
      contact.daterecorded,
    ]) || [];

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 65,
    styles: {
      fontSize: 9,
      cellPadding: 3,
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: [252, 156, 28],
      textColor: [0, 0, 0],
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },
    margin: { top: 60, bottom: 25 },

   didDrawPage: function (data) {
  const pageCount = doc.internal.getNumberOfPages();
  const page = doc.internal.getCurrentPageInfo().pageNumber;

  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;

  // =========================
  // FAVICON
  // =========================
  const iconSize = 8;

  // only draw if base64 available
  if (faviconBase64) {
    doc.addImage(
      faviconBase64,
      "PNG",
      14,
      pageHeight - 16,
      iconSize,
      iconSize
    );
  }

  // =========================
  // FOOTER TEXT
  // =========================
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");

  doc.text(
    "Terraweb.africa — Empowering through technology",
    25,
    pageHeight - 10
  );

  // =========================
  // COPYRIGHT + PAGE
  // =========================
  doc.setFont("helvetica", "bold");

  // doc.text(
  //   `© 2026 All Rights Reserved`,
  //   pageWidth - 90,
  //   pageHeight - 10
  // );

doc.text(
  `Page ${page} of ${pageCount}`,
  pageWidth - 15,
  pageHeight - 10,
  { align: "right" }
);
}
  });
const safeDate = new Date()
  .toISOString()
  .replace(/T/, "_")
  .replace(/:/g, "-")
  .split(".")[0];

const fileName = `${companyName}_farmer_records_${safeDate}.pdf`;

doc.save(fileName);
};

  // const handleDownloadTable = () => {
  //   const doc = new jsPDF();

  //   const currentDate = new Date().toLocaleString();

  //   // Header
  //   doc.setFontSize(16);
  //   doc.text('Terraweb.africa', 14, 15);
  //   doc.setFontSize(11);
  //   doc.text('Empowering farmers through technology', 14, 22);
  //   doc.setFontSize(10);
  //   doc.text(`Generated on: ${currentDate}`, 14, 28);

  //   // Table data
  //   const tableColumn = [
  //     'ID',
  //     'Farmer ID',
  //     'Product Type',
  //     'Weight',
  //     'Company',
  //     'Full Name',
  //     'Recorded',
  //   ];

  //   const tableRows = contacts?.map((contact) => [
  //     contact.id,
  //     contact.farmerid,
  //     contact.producttype,
  //     contact.weight,
  //     contact.companyname,
  //     contact.fullname,
  //     contact.daterecorded,
  //   ]) || [];

  //   autoTable(doc, {
  //     head: [tableColumn],
  //     body: tableRows,
  //     startY: 35,
  //     styles: { fontSize: 9, color: "black" },
  //     headStyles: { fillColor: [252, 156, 28] },
  //     margin: { top: 35, bottom: 20 },
  //     didDrawPage: function (data) {
  //       // Footer
  //       const pageCount = doc.internal.getNumberOfPages();
  //       doc.setFontSize(9);
  //       doc.text(
  //         `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
  //         data.settings.margin.left,
  //         doc.internal.pageSize.height - 10
  //       );

  //       // Footer text
  //       doc.text(
  //         '© Terraweb.africa — All rights reserved.',
  //         data.settings.margin.left + 70,
  //         doc.internal.pageSize.height - 10
  //       );
  //     },
  //   });

  //   // Save PDF
  //   doc.save('farmer_records.pdf');
  // };



  //pagination next
  const handlePageNext = () => {

  }

  const handlePagePrevious = () => {

  }

  const scrollToFirstName = () => {
    firtNameRef.current?.scrollIntoView({ behavior: "smooth", block: "center" })
    firtNameRef.current?.focus();
  }




  const getFilteredRecords = () => {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    // let filtered = contacts.filter((c) => {
    //   const recordDate = new Date(c.daterecorded);

    //   if (viewMode === "approved") {
    //     return c.approved_status === "approved";
    //   }

    //   if (viewMode === "not_approved") {
    //     return c.approved_status !== "approved";
    //   }

    //   if (viewMode === "monthly") {
    //     return (
    //       recordDate.getMonth() === currentMonth &&
    //       recordDate.getFullYear() === currentYear
    //     );
    //   }

    //   if (viewMode === "yearly") {
    //     return recordDate.getFullYear() === currentYear;
    //   }

    //   return true;
    // });

    let filtered = contacts.filter((c) => {
  const recordDate = new Date(c.daterecorded);

  // SEARCH
  const q = searchRecord.toLowerCase();

  const matchesSearch =
    !q ||
    c.fullname?.toLowerCase().includes(q) ||
    c.farmerid?.toLowerCase().includes(q) ||
    c.producttype?.toLowerCase().includes(q) ||
    c.company?.toLowerCase().includes(q);

  if (!matchesSearch) return false;

  // VIEW MODE
  if (viewMode === "approved") {
    return c.approved_status === "approved";
  }

  if (viewMode === "not_approved") {
    return c.approved_status !== "approved";
  }

  if (viewMode === "monthly") {
    return (
      recordDate.getMonth() === currentMonth &&
      recordDate.getFullYear() === currentYear
    );
  }

  if (viewMode === "yearly") {
    return recordDate.getFullYear() === currentYear;
  }

  return true;
});

    // SORTING
    if (sortColumn) {
      filtered.sort((a, b) => {
        let valueA = a[sortColumn];
        let valueB = b[sortColumn];

        // handle nulls
        if (!valueA) valueA = "";
        if (!valueB) valueB = "";

        // dates
        if (
          sortColumn === "daterecorded" ||
          sortColumn === "date_approved"
        ) {
          valueA = new Date(valueA).getTime() || 0;
          valueB = new Date(valueB).getTime() || 0;
        }

        // numbers
        else if (
          sortColumn === "id" ||
          sortColumn === "weight"
        ) {
          valueA = Number(valueA);
          valueB = Number(valueB);
        }

        // strings
        else {
          valueA = valueA.toString().toLowerCase();
          valueB = valueB.toString().toLowerCase();
        }

        if (valueA < valueB) {
          return sortDirection === "asc" ? -1 : 1;
        }

        if (valueA > valueB) {
          return sortDirection === "asc" ? 1 : -1;
        }

        return 0;
      });
    }

    return filtered;
  };


  const getSummary = (records) => {
    const totalWeight = records.reduce(
      (sum, r) => sum + Number(r.weight || 0),
      0
    );

    return {
      totalRecords: records.length,
      totalWeight,
    };
  };

  // const filteredRecords = getFilteredRecords();
  const filteredRecords = getFilteredRecords();

  const indexOfLastRecord =
    currentPage * recordsPerPage;

  const indexOfFirstRecord =
    indexOfLastRecord - recordsPerPage;

  const currentRecords =
    filteredRecords.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );

  const totalPages = Math.ceil(
    filteredRecords.length / recordsPerPage
  );

  const summary = getSummary(filteredRecords);


  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection((prev) =>
        prev === "asc" ? "desc" : "asc"
      );
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };


  const handleSelectRecord = (id) => {
    setSelectedRecords((prev) =>
      prev.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id]
    );
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedRecords(currentRecords.map((r) => r.id));
    } else {
      setSelectedRecords([]);
    }
  };

 
  return (


    // with improvements
    // <div className="records-app-container center mt6  ">

  
     <div className="records-app-container center mt6 vh-100">
      {isLoading ? (
        <div className="db mb2">
          <Circles type="Oval" color="#000080" height={40} width={80} />
        </div>
      ) : null}
<div className="dib-l br4 shadow-3">

  {/* Profile card — its own section, not part of the search/pagination row */}
  <div className="flex items-center bg-white  pa3 mb3 w-100">
 <div className="mr3">
  <img
    className="br-100"
    style={{ height: '10rem', width: '10rem', objectFit: 'cover' }}
    alt="profile"
    src={
      profile?.gender === "female"
        ? "/img/femaleavatar.jpg"
        : "/img/maleavatar.jpeg"
    }
  />
</div>

    <div className="lh-copy">
      <h1 className="f2 b gold ma0 ttu">{profile?.username || ""}</h1>

      {profile?.status && (
        <span
          className={`dib br-pill ph2 pv1 f6 fw7 mv1 ${
            profile.status === "active"
              ? "bg-light-green dark-green"
              : "bg-light-red dark-red"
          }`}
        >
          {profile.status === "active" ? "● Active" : "⛔ Suspended"}
        </span>
      )}

      <div className="f2 black">{profile?.company || "No company assigned"}</div>
    </div>
  </div>

  <RecordsDashboardClerk />

  {/* Search + pagination row — controlContainer's actual intended job */}
  <div className="controlContainer bg-white  w-100">
    <div className="grid-item">
      <input
        type="text"
        className="searchInput"
        placeholder="Search farmer Record"
        onChange={onSearchChange}
      />
      <label className="pa1 hover-bg-transparent" onClick={searchRecords}>
        <i className="fas fa-search f2 hover-gold orange"></i>
      </label>
    </div>

<div className="grid-item flex items-center ">
      <div className="flex items-center">
           <label className="f2 fw6 mv0">
        <b>{indexOfFirstRecord + 1}</b>–
        <b>{Math.min(indexOfLastRecord, filteredRecords.length)}</b> of{' '}
        <b>{filteredRecords.length}</b>
      </label>
      </div>
    <div className="grid-item flex items-center ">

   

      {/* <div className="flex items-center"> */}
        <button
          className="bn bg-transparent pa2 pointer flex items-center justify-center"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          aria-label="Previous page"
        >
          <i className="fas fa-caret-left f1 dark-gray hover-gold"></i>
        </button>

        <button
          className="bn bg-transparent pa2 pointer flex items-center justify-center ml3 mr3"
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          aria-label="Next page"
        >
          <i className="fas fa-caret-right f1 dark-gray hover-gold"></i>
        </button>

        <label className="pa2 pointer" onClick={handleDownloadTable}>
          <i className="fas fa-download f1 hover-gold"></i>
        </label>

        <label
          className="br-pill bg-orange white f5 b pa2 ph3 hover-bg-orange hover-white pointer dib ml2"
          onClick={scrollToFirstName}
        >
          Add
        </label>
      {/* </div> */}
    </div>
    </div>
  </div>

</div>
    

      <div className="bg-white br3 shadow-2 pa3 mb3">

        <div className="flex flex-column flex-row-l justify-between items-start items-center-l">

          {/* Filters */}
          <div className="mb3 mb0-l">
            <RecordsFilterBar
              viewMode={viewMode}
              setViewMode={setViewMode}
            />
          </div>

        

        </div>

      </div>

      <div className="records-table-wrapper">

        <div className="records-table-scroll">

          {/* <RecordsFilteredView
            records={filteredRecords}
            editContactId={editContactId}
            editFormData={editFormData}
            handleEditClick={handleEditClick}
            handleDeleteClick={handleDeleteClick}
            handleDownloadRow={handleDownloadRow}
            handleEditFormChange={handleEditFormChange}
            handleEditFormSubmit={handleEditFormSubmit}
            handleCancelClick={handleCancelClick}
            isLoadingSave={isLoadingSave}
            deletingId={deletingId}
            selectedRecords={selectedRecords}
            handleSelectRecord={handleSelectRecord}
            selectAll={selectAll}
            handleSelectAll={handleSelectAll}
            sortColumn={sortColumn}
            sortDirection={sortDirection}
            handleSort={handleSort}
          /> */}

<RecordsFilteredView
  records={currentRecords}
  editContactId={editContactId}
  editFormData={editFormData}
  handleEditClick={handleEditClick}
  handleDeleteClick={handleDeleteClick}
  handleDownloadRow={handleDownloadRow}
  handleEditFormChange={handleEditFormChange}
  handleEditFormSubmit={handleEditFormSubmit}
  handleCancelClick={handleCancelClick}
  isLoadingSave={isLoadingSave}
 
  selectedRecords={selectedRecords}
  handleSelectRecord={handleSelectRecord}
  selectAll={selectAll}
  handleSelectAll={handleSelectAll}
  sortColumn={sortColumn}
  sortDirection={sortDirection}
  handleSort={handleSort}
/>
        </div>

      </div>
      <div>
        {success && <p className="green f2 b">{success}</p>}
        {foundErrAdd && <p className="red f2 b">{foundErrAdd}</p>}

        <button
          className="ml2 br-pill bg-white orange f3 pa3 b mt2 hover-bg-orange hover-white"
          onClick={refreshRecords}
        >
          Refresh
        </button>
      </div>

      <div className="recordsdiv">
        <h2 className="f3 b gold">Add New Record</h2>

        <div className="form-grid">
          {/* Company selection */}
          {/* FIX (#5): locked to the admin's own society. Value is always
              synced from profile.company via the fetchProfile effect, and
              the select is disabled so it can never be changed manually. */}
          <div>
            <label className="b f5 db mb2">Company</label>
            <select
              className=""
              onChange={onCompanyChange}
              ref={companyRef}
              value={addFormData.company}
              disabled
              title="You can only add records for your own company"
            >
              <option value={addFormData.company}>
                {addFormData.company || "No company assigned"}
              </option>
            </select>
          </div>

          {/* Farmer ID + Lookup */}
          <div>
            <label className="b f5 db mb2">Farmer ID</label>
            <input
              type="text"
              name="farmerid"
              value={addFormData.farmerid}
              placeholder="Enter Farmer ID"
              onChange={handleAddFormChange}
            />
            <button
              type="button"
              className={`lookup-btn ${isLoadingAdd ? "lookup-btn-disabled" : ""
                }`}
              onClick={handleLookupFarmerID}
              disabled={isLoadingAdd}
            >
              {isLoadingAdd ? (
                <>
                  <i className="fas fa-spinner fa-spin mr2"></i>
                  Looking up...
                </>
              ) : (
                <>
                  <i className="fas fa-search mr2"></i>
                  Lookup Farmer
                </>
              )}
            </button>
          </div>

          {foundFarmer && (
            <div
              className={
                foundFarmer.success
                  ? "lookup-card-success"
                  : "lookup-card-error"
              }
            >
              {/* dismiss button */}
              <button
                type="button"
                className="lookup-close-btn"
                onClick={clearFoundFarmer}
              >
                ×
              </button>

              {foundFarmer.success ? (
                <>
                  <div className="lookup-header">
                    <div className="lookup-icon-success">
                      <i className="fas fa-check-circle"></i>
                    </div>

                    <div>
                      <div className="lookup-title">
                        {foundFarmer.message}
                      </div>

                      <div className="lookup-subtitle">
                        Farmer found successfully
                      </div>
                    </div>
                  </div>

                  <div className="lookup-details">
                    <div className="lookup-row">
                      <span className="lookup-label">
                        Farmer Name
                      </span>

                      <span className="lookup-value">
                        {foundFarmer.data.fullname}
                      </span>
                    </div>

                    <div className="lookup-row">
                      <span className="lookup-label">
                        Farmer ID
                      </span>

                      <span className="lookup-value">
                        {foundFarmer.data.farmerid}
                      </span>
                    </div>
                    <div className="lookup-row">
                      <span className="lookup-label">
                        Company
                      </span>

                      <span className="lookup-value">
                        {foundFarmer.data.company}
                      </span>
                    </div>
                  </div>

                  <div className="lookup-actions">
                    <button
                      type="button"
                      className="lookup-autofill-btn"
                      onClick={() => {
                        handleAutofillNames();
                        clearFoundFarmer();
                      }}
                    >
                      <i className="fas fa-magic mr2"></i>
                      Autofill Names
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="lookup-header">
                    <div className="lookup-icon-error">
                      <i className="fas fa-times-circle"></i>
                    </div>

                    <div>
                      <div className="lookup-title-error">
                        {foundFarmer.error}
                      </div>

                      <div className="lookup-subtitle">
                        No farmer record found
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}

          {/* First Name */}
          <div>
            <label className="b f5 db mb2">First Name</label>
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              ref={firtNameRef}
              value={addFormData.firstName}
              onChange={handleAddFormChange}
            />
          </div>

          {/* Last Name */}
          <div>
            <label className="b f5 db mb2">Last Name</label>
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={addFormData.lastName}
              ref={lastNameRef}
              onChange={handleAddFormChange}
            />
          </div>

          {/* Product type */}
          {/* FIX (#4): bound to addFormData.producttype (single source of
              truth) instead of the separate `names` state, so the reset
              after a successful add actually clears the dropdown. */}
          <div>
            <label className="b f5 db mb2">Product Type</label>
            <select
              className=""
              value={addFormData.producttype}
              name="producttype"
              onChange={onProducttypeChange}
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
          </div>

          {/* Weight */}
          <div>
            <label className="b f5 db mb2">Weight (kg)</label>
            <input
              type="number"
              name="weight"
              value={addFormData.weight}
              placeholder="Enter weight"
              onChange={handleAddFormChange}
            />
          </div>
        </div>

        {/* Button + loading */}
        <div className="mt3">
          {isLoadingAdd ? (
            <div className="dib pa3">
              <Circles type="Oval" color="#000080" height={30} width={40} />
            </div>
          ) : (
            <label
              className="br-pill bg-orange white f5 b pa2 hover-bg-orange hover-white pointer dib"
              onClick={handleAddFormSubmit}
            >
              Add
            </label>
          )}
        </div>

        {successAdd && (
          <div className="br-pill bg-light-green pa2 mt2">
            <label className="f5 green b">
              {typeof successAdd === "string"
                ? successAdd
                : successAdd.message}
            </label>
          </div>
        )}

        {foundErrAdd && (
          <label className="f5 red b db mt2">{foundErrAdd}</label>
        )}

        {/* Footer note */}
        <div className="bg-white shadow-3 pa3 br4 mt3">
          <label className="f5 b black db mb1">Note:</label>
          <span className="f5 black">
            You can only add or edit a record for a farmer that belongs to your designated company.
          </span>
        </div>
      </div>

    </div>
     

    
  );
};

export default Records;


